import { Pause, Play } from 'lucide-react';
import { useDispatch } from 'react-redux';
import UDText from 'ud-ui/components/text';

import { DivProps } from 'typings';
import { millisToMinutesAndSeconds } from 'modules/overlay-v2/domain/utils/convert-time';
import usePopupMessenger from 'modules/overlay-v2/ui/hooks/use-popup-messenger';
import { setPeriod, toggleTimer } from 'modules/overlay-v2/store/time/time';
import useTime from 'modules/overlay-v2/ui/hooks/use-time';
import useTimer from 'modules/overlay-v2/ui/hooks/use-timer';
import ValueBlock from 'modules/overlay-v2/ui/components/components/value-block';
import Counter from './counter';
import { CountButton, PanelItemWrapper, PlayerController } from './styles';
import { theme } from 'styles/theme/theme';

function Period(props: DivProps) {
  const { className = '', style, ...rest } = props;
  const dispatch = useDispatch();
  const { period } = useTime();
  const { timer, setTimer, addToTimer, isActive } = useTimer();
  const { send } = usePopupMessenger();

  const onClickToggler = () => {
    dispatch(toggleTimer());
    send({ type: 'toggleTimer', isActive: !isActive });
  };

  const onChangePeriod = (num: number) => {
    setTimer(0);
    dispatch(setPeriod(num));
    send({ type: 'setPeriod', period: num });
  };

  const handleAddToTimer = (num: number) => {
    addToTimer(num);
    send({ type: 'setTimer', milliseconds: timer + num });
  };

  return (
    <PanelItemWrapper className={'flex-center flex-col ' + className} style={{ gap: 6, maxHeight: 122, ...style }} {...rest}>
      <UDText style={{ flexGrow: 1 }} type={'headline'} color={theme.colors.Gray}>
        Тайм
      </UDText>
      <div className={'flex items-center'} style={{ width: '100%', height: 30, justifyContent: 'space-between', gap: 10 }}>
        <PlayerController className={'flex-center'} onClick={onClickToggler}>
          {isActive ? <Pause size={20} fill={'white'} color={'white'} /> : <Play size={20} fill={'white'} color={'white'} />}
        </PlayerController>
        <Counter value={period} setValue={onChangePeriod} />
        <ValueBlock
          text={millisToMinutesAndSeconds(timer)}
          textSize={'large'}
          className={'flex-center'}
          style={{ width: 70, height: 30 }}
        />
      </div>
      <div className={'flex flex-row justify-between'} style={{ gap: 4, width: '100%' }}>
        <CountButton style={{ fontSize: 8, color: theme.colors.Gray }} onClick={() => handleAddToTimer(-10 * 1000)}>
          -10
        </CountButton>
        <CountButton style={{ fontSize: 8, color: theme.colors.Gray }} onClick={() => handleAddToTimer(-5 * 1000)}>
          -5
        </CountButton>
        <CountButton style={{ fontSize: 8, color: theme.colors.Gray }} onClick={() => handleAddToTimer(-1 * 1000)}>
          -1
        </CountButton>
        <CountButton style={{ fontSize: 8, color: theme.colors.Gray }} onClick={() => handleAddToTimer(1000)}>
          +1
        </CountButton>
        <CountButton style={{ fontSize: 8, color: theme.colors.Gray }} onClick={() => handleAddToTimer(5 * 1000)}>
          +5
        </CountButton>
        <CountButton style={{ fontSize: 8, color: theme.colors.Gray }} onClick={() => handleAddToTimer(10 * 1000)}>
          +10
        </CountButton>
      </div>
    </PanelItemWrapper>
  );
}

export default Period;
